import { useTranslation } from "@/lib/i18n";
import { DimensionValueSet } from "@/lib/dimensions";

interface LegendDimensionsProps {
  dimensionValues: DimensionValueSet;
}

const LegendDimensions = ({ dimensionValues }: LegendDimensionsProps) => {
  const { t } = useTranslation();
  return (
    <>
      {Object.entries(dimensionValues).map(([id, dimension]) => (
        <div style={{ marginBottom: 10 }} key={id}>
          <strong>
            {t(`map.dimension_names.${id}`, {
              defaultValue: id,
            })}
            :
          </strong>
          <pre style={{ margin: 0 }}>{dimension.queryStringValue}</pre>
        </div>
      ))}
    </>
  );
};

export default LegendDimensions;
